import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-drawingcommentsvendor',
  templateUrl: './drawingcommentsvendor.component.html',
  styleUrls: ['./drawingcommentsvendor.component.css']
})
export class DrawingcommentsvendorComponent implements OnInit {

  vModelData : any;
  constructor() { }

  ngOnInit() {
  }

  SubmitEnlistmentForm(form : NgForm)
  {
    
  }

}
